import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class SimpleInputModule {
}
SimpleInputModule.ɵfac = function SimpleInputModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleInputModule)(); };
SimpleInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SimpleInputModule });
SimpleInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, IconModule, TooltipModule] });
